/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gradelevel_Grade_10_Or_Lower13Inputs */

const en__field__enum_gradelevel_grade_10_or_lower13 = /** @type {(inputs: _Field__Enum_Gradelevel_Grade_10_Or_Lower13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade 10 or lower`)
};

const de__field__enum_gradelevel_grade_10_or_lower13 = /** @type {(inputs: _Field__Enum_Gradelevel_Grade_10_Or_Lower13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Klasse oder niedriger`)
};

/**
* | output |
* | --- |
* | "Grade 10 or lower" |
*
* @param {_Field__Enum_Gradelevel_Grade_10_Or_Lower13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gradelevel_grade_10_or_lower13 = /** @type {((inputs?: _Field__Enum_Gradelevel_Grade_10_Or_Lower13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gradelevel_Grade_10_Or_Lower13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gradelevel_grade_10_or_lower13(inputs)
	return de__field__enum_gradelevel_grade_10_or_lower13(inputs)
});
export { _field__enum_gradelevel_grade_10_or_lower13 as "_field__enum_gradeLevel_GRADE_10_OR_LOWER" }